var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAccess)?_c('v-content',[_c('AdminLayout',[_c('router-view')],1)],1):_c('NotFound')}
var staticRenderFns = []

export { render, staticRenderFns }